import {useMutation, UseMutationResult} from '@tanstack/react-query';

import {useLocale} from '../../provider/locale/locale-hook';
import {useSnackbar} from '../../provider/snackbar/snackbar-hook';
import {ApiError} from '../../util/error';
import {HttpCodeEnum} from '../../util/fetch-const';

import {DirectorReportSendRequestType, DirectorReportSendResponseType, sendDirectorReport} from './director-report-api';

export function useSendDirectorReportMutation(): UseMutationResult<
    DirectorReportSendResponseType,
    unknown,
    DirectorReportSendRequestType
> {
    const {snackbar} = useSnackbar();
    const {getLocalizedString} = useLocale();

    function onSuccess(_data: DirectorReportSendResponseType, variables: DirectorReportSendRequestType) {
        snackbar.success(getLocalizedString('DIRECTOR_REPORT__SUCCESS', {email: variables.email}));
    }

    function onError(error: unknown) {
        if (error instanceof ApiError && error.statusCode === HttpCodeEnum.BadRequest) {
            snackbar.error(getLocalizedString('DIRECTOR_REPORT__ERROR_INVALID_EMAIL'));

            return;
        }

        snackbar.error(getLocalizedString('DIRECTOR_REPORT__ERROR_GENERIC'));
    }

    return useMutation(sendDirectorReport, {onSuccess, onError});
}
